/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popMineTip.vue?vue&type=template&id=ba779dde&scoped=true"
import script from "./popMineTip.vue?vue&type=script&lang=js"
export * from "./popMineTip.vue?vue&type=script&lang=js"
import style0 from "./popMineTip.vue?vue&type=style&index=0&id=ba779dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba779dde",
  null
  
)

export default component.exports